// import ApiClient from "../helpers/ApiClient";
// import axios from "axios";
// import { API } from "../config/config";
// import { clearUserDetailsInLocalStorage } from "../helpers/UserDetails";
// import useSWR from "swr";

// export async function signIn(username, password) {
//     axios.defaults.withCredentials = true;
//     try {
//         const response = await axios.post(`${API}/auth/signin`, {
//             username, password
//         });

//         // ✅ FIX: Your backend returns data directly, not nested in response.data
//         // Check the actual response structure from your backend
//         console.log('🔍 Raw login response:', response);
        
//         // If your backend returns {success: true, message: "...", accessToken: "...", user: {...}}
//         // then the data is in response.data directly
//         if (response.data && response.data.success) {
//             return {
//                 status: response.status,
//                 data: response.data // This contains success, message, accessToken, user
//             };
//         } else {
//             throw new Error(response.data?.message || 'Login failed');
//         }
//     } catch (error) {
//         console.error('❌ Login error:', error.response?.data || error.message);
//         throw error;
//     }
// }

// export async function signUp(biz_name, username, password) {
//     axios.defaults.withCredentials = true;
//     try {
//         const response = await axios.post(`${API}/auth/signup`, {
//             biz_name, username, password
//         });

//         return response;
//     } catch (error) {
//         throw error;
//     }
// }

// export async function signOut() {
//     axios.defaults.withCredentials = true;
//     try {
//         const response = await ApiClient.post(`${API}/auth/signout`);

//         clearUserDetailsInLocalStorage();

//         return response;
//     } catch (error) {
//         throw error;
//     }
// }

// export async function forgotPassword(email) {
//     axios.defaults.withCredentials = true;
//     try {
//         const response = await axios.post(`${API}/auth/forgot-password`, {
//             username: email
//         });

//         return response;
//     } catch (error) {
//         throw error;
//     }
// }

// export async function resetPassword(token, password) {
//     axios.defaults.withCredentials = true;
//     try {
//         const response = await axios.post(`${API}/auth/reset-password/${token}`, {
//             password
//         });

//         return response;
//     } catch (error) {
//         throw error;
//     }
// }

// export async function getStripeSubscriptionURL(productLookupKey) {
//     axios.defaults.withCredentials = true;
//     try {
//         const response = await ApiClient.post(`${API}/auth/stripe-product-lookup`, {
//             id: productLookupKey
//         });
//         return response;
//     } catch (error) {
//         throw error;
//     }
// }


// const fetcher = (url) => ApiClient.get(url).then((res) => res.data);

// export function useSubscriptionDetails() {
//   const APIURL = `/auth/subscription-details`;
//   const { data, error, isLoading } = useSWR(APIURL, fetcher);
//   return {
//     data,
//     error,
//     isLoading,
//     APIURL,
//   };
// }

// export async function cancelSubscription(subscriptionId) {
//     axios.defaults.withCredentials = true;
//     try {
//         const response = await ApiClient.post(`${API}/auth/cancel-subscription`, {
//             id: subscriptionId
//         });
//         return response;
//     } catch (error) {
//         throw error;
//     }
// }
// controllers/auth.controller.js
import ApiClient from "../helpers/ApiClient";
import { clearUserDetailsInLocalStorage } from "../helpers/UserDetails";
import useSWR from "swr";
import axios from "axios";

const fetcher = (url) => ApiClient.get(url).then((res) => res.data);

import { getSyncMode } from "../config/config";

// SIGN IN
export async function signIn(username, password) {
  const isLocalApp = window.location.port === '5001' || navigator.userAgent.toLowerCase().includes('electron') || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const syncMode = getSyncMode();
  
  if (isLocalApp) {
    if (syncMode === 'online_only') {
      // In Online-Only mode, internet is strictly required. No offline SQLite fallback.
      try {
        console.log("[SignIn] Online-Only mode active. Authenticating against Cloud...");
        const cloudResponse = await axios.post("https://ehospitalitynepal.com/api/v1/auth/signin", { 
          username, 
          password 
        }, { withCredentials: false });

        if (cloudResponse.data?.success) {
          return {
            status: cloudResponse.status,
            data: cloudResponse.data
          };
        } else {
          throw new Error(cloudResponse.data?.message || 'Login failed');
        }
      } catch (cloudError) {
        const msg = cloudError.response?.data?.message || (navigator.onLine ? cloudError.message : "Internet connection is required in Online-Only mode.");
        throw new Error(msg);
      }
    } else {
      // Offline-sync mode: Try Cloud first (to keep credentials fresh), if offline fall back to local SQLite
      try {
        console.log("[SignIn] Electron + Online. Authenticating against Cloud...");
        const cloudResponse = await axios.post("https://ehospitalitynepal.com/api/v1/auth/signin", { 
          username, 
          password 
        }, { withCredentials: false });

        console.log("[SignIn] Cloud auth successful:", cloudResponse.data);

        if (cloudResponse.data?.success) {
          // Sync user details to local SQLite database so offline login will work in the future
          try {
            await ApiClient.post("/auth/local-sync", {
              accessToken: cloudResponse.data.accessToken,
              user: cloudResponse.data.user,
              password: password
            });
            console.log("[SignIn] Successfully synced cloud user profile locally.");
          } catch (localSyncErr) {
            console.error("[SignIn] Failed to sync cloud user profile locally:", localSyncErr);
          }

          return {
            status: cloudResponse.status,
            data: cloudResponse.data
          };
        }
      } catch (cloudError) {
        console.warn("[SignIn] Cloud auth failed, falling back to local SQLite login:", cloudError.message);
      }
    }
  }

  // Fallback / standard offline flow
  try {
    const response = await ApiClient.post("/auth/signin", { username, password });
    console.log('Raw login response:', response);

    if (response.data?.success) {
      return {
        status: response.status,
        data: response.data
      };
    } else {
      throw new Error(response.data?.message || 'Login failed');
    }
  } catch (error) {
    console.error('Login error:', error.response?.data || error.message);
    throw error;
  }
}

// SIGN UP
export async function signUp(biz_name, username, password) {
  try {
    const response = await ApiClient.post("/auth/signup", { biz_name, username, password });
    return response;
  } catch (error) {
    throw error;
  }
}

// SIGN OUT
export async function signOut() {
  try {
    const response = await ApiClient.post("/auth/signout");
    clearUserDetailsInLocalStorage();
    return response;
  } catch (error) {
    throw error;
  }
}

// FORGOT PASSWORD
export async function forgotPassword(email) {
  try {
    return await ApiClient.post("/auth/forgot-password", { username: email });
  } catch (error) {
    throw error;
  }
}

// RESET PASSWORD
export async function resetPassword(token, password) {
  try {
    return await ApiClient.post(`/auth/reset-password/${token}`, { password });
  } catch (error) {
    throw error;
  }
}

// STRIPE
export async function getStripeSubscriptionURL(productLookupKey) {
  try {
    return await ApiClient.post("/auth/stripe-product-lookup", { id: productLookupKey });
  } catch (error) {
    throw error;
  }
}

// SWR HOOK
export function useSubscriptionDetails() {
  const { data, error, isLoading } = useSWR("/auth/subscription-details", fetcher);
  return { data, error, isLoading };
}

// CANCEL SUBSCRIPTION
export async function cancelSubscription(subscriptionId) {
  try {
    return await ApiClient.post("/auth/cancel-subscription", { id: subscriptionId });
  } catch (error) {
    throw error;
  }
}